/**
 * The entry point.
 *
 * The service worker comes deliberately AFTER the first render: the
 * registration fetches the whole app into the cache, dictionary and fonts
 * included, and that would stand in the way of the first picture. Whoever
 * opens Kritzl wants to write, not to install.
 */

import { render } from 'preact'
import { App } from './App.js'
import './ui/style.css'

const root = document.getElementById('app')
if (root) render(<App />, root)

/**
 * Registers the service worker — afterwards the app runs without a network
 * as well.
 *
 * The module comes from vite-plugin-pwa and exists only in the build; in
 * development it is a stub that does nothing. A new version is taken over by
 * itself at the next start (registerType: 'autoUpdate') — a dialog asking
 * whether one wants to update would be a question that Elmar cannot answer.
 */
async function registerServiceWorker(): Promise<void> {
  try {
    const { registerSW } = await import('virtual:pwa-register')
    registerSW({ immediate: true, onRegisterError: () => {} })
  } catch {}
}

void registerServiceWorker()
